import { api, ApiError } from '@/lib/api-client';

interface SampleBatch {
  id: string;
  jobTypeId: string;
  name: string;
  records: Array<{ id: string; index: number; headerData: Record<string, unknown>; fieldValues: Record<string, unknown> }>;
}

// Sample-batch admin client. Routes through `api` so 401s bounce to Suite SSO.
export const sampleBatchApi = {
  list: (jobTypeId: string) => api.get<SampleBatch[]>(`/job-types/${jobTypeId}/sample-batches`),

  current: (jobTypeId: string) =>
    api.get<SampleBatch | null>(`/job-types/${jobTypeId}/sample-batches/current`).catch((e) => {
      if (e instanceof ApiError && e.status === 404) return null;
      throw e;
    }),

  create: (
    jobTypeId: string,
    body: {
      name: string;
      records: Array<{ headerData: Record<string, unknown>; fieldValues: Record<string, unknown> }>;
    },
  ) => api.post<SampleBatch>(`/job-types/${jobTypeId}/sample-batches`, body),

  update: (
    id: string,
    body: {
      name?: string;
      records?: Array<{ headerData: Record<string, unknown>; fieldValues: Record<string, unknown> }>;
    },
  ) => api.put<SampleBatch>(`/job-type-sample-batches/${id}`, body),

  activate: (id: string) =>
    api.post<{ ok: true }>(`/job-type-sample-batches/${id}/activate`),

  remove: (id: string) => api.delete<void>(`/job-type-sample-batches/${id}`),
};

export type { SampleBatch };
